// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--M_c56","small":"styles-module__small--uP4ZH","isCoastal":"styles-module__isCoastal--OHDSA"};